"use strict";

(() => {
	class Fuel_Consumption_Calculator {
		/** @var {HTMLElement} */
		#$widget;

		/** @var {NodeListOf<HTMLInputElement>} */
		#$carTypeInputs;

		/** @var {HTMLInputElement} */
		#$distanceInput;

		/** @var {HTMLInputElement} */
		#$electricDistanceInput;

		/** @var {HTMLInputElement} */
		#$electricConsumptionInput;

		/** @var {HTMLInputElement} */
		#$electricPriceInput;

		/** @var {HTMLInputElement} */
		#$fuelConsumptionInput;

		/** @var {HTMLInputElement} */
		#$fuelPriceInput;


		/** @var {HTMLElement} */
		#$electricSection;

		/** @var {HTMLElement} */
		#$electricDistanceSection;

		/** @var {HTMLElement} */
		#$fuelSetion;


		/** @var {HTMLElement} */
		#$tripPriceResult;

		/** @var {HTMLElement} */
		#$kmPriceResult;

		/** @var {HTMLElement} */
		#$consumedElectricityResult;

		/** @var {HTMLElement} */
		#$consumedFuelResult;


		constructor($widget) {
			this.#$widget = $widget;
		}

		initialize() {
			// Initialize elements.
			this.#$carTypeInputs            = this.#$widget.querySelectorAll(".dan-inputs-car-type input[type='radio']");
			this.#$distanceInput            = this.#$widget.querySelector(".dan-input-distance");
			this.#$electricDistanceInput    = this.#$widget.querySelector(".dan-input-electric-distance");
			this.#$electricConsumptionInput = this.#$widget.querySelector(".dan-input-electric-consumption");
			this.#$electricPriceInput       = this.#$widget.querySelector(".dan-input-electric-price");
			this.#$fuelConsumptionInput     = this.#$widget.querySelector(".dan-input-fuel-consumption");
			this.#$fuelPriceInput           = this.#$widget.querySelector(".dan-input-fuel-price");

			this.#$electricSection         = this.#$widget.querySelector(".dan-section-electric");
			this.#$electricDistanceSection = this.#$widget.querySelector(".dan-section-electric-distance");
			this.#$fuelSetion              = this.#$widget.querySelector(".dan-section-fuel");

			this.#$tripPriceResult           = this.#$widget.querySelector(".dan-result-price-trip");
			this.#$kmPriceResult             = this.#$widget.querySelector(".dan-result-price-km");
			this.#$consumedElectricityResult = this.#$widget.querySelector(".dan-result-consumed-electricity");
			this.#$consumedFuelResult        = this.#$widget.querySelector(".dan-result-consumed-fuel");

			// Add handlers to events.
			for (const $input of this.#$carTypeInputs) {
				$input.addEventListener("change", () => {
					this.#refreshSectionsVisibility();
					this.#refreshResults();
				});
			}

			this.#$distanceInput.addEventListener("input", this.#refreshResults.bind(this));
			this.#$electricDistanceInput.addEventListener("input", this.#refreshResults.bind(this));
			this.#$electricConsumptionInput.addEventListener("input", this.#refreshResults.bind(this));
			this.#$electricPriceInput.addEventListener("input", this.#refreshResults.bind(this));
			this.#$fuelConsumptionInput.addEventListener("input", this.#refreshResults.bind(this));
			this.#$fuelPriceInput.addEventListener("input", this.#refreshResults.bind(this));

			// Initialize tooltips.
			const $tooltips = this.#$widget.querySelectorAll("[data-tooltip]");

			if ($tooltips.length > 0) {
				// noinspection JSUnresolvedReference
				tippy($tooltips, {
					content: ($element) => $element.getAttribute("data-tooltip"),
					allowHTML: true
				});
			}

			// Refresh on load.
			this.#refreshSectionsVisibility();
			this.#refreshResults();
		}

		#refreshSectionsVisibility() {
			const inputs = this.#getInputs();

			const electricVisible = (
				inputs.carType === "electric"
				|| inputs.carType === "plugin"
			);

			const electricDistanceVisible = (inputs.carType === "plugin");
			const fuelVisible             = (
				inputs.carType === "standard"
				|| inputs.carType === "plugin"
			);

			this.#setSectionVisibility(this.#$electricSection, electricVisible);
			this.#setSectionVisibility(this.#$electricDistanceSection, electricDistanceVisible);
			this.#setSectionVisibility(this.#$fuelSetion, fuelVisible);
		}

		#setSectionVisibility($section, visible) {
			if (visible && !$section.classList.contains("-expanded")) {
				$section.classList.add("-expanded");
				$section.style.height = $section.scrollHeight + "px";

				setTimeout(() => {
					$section.style.height = "auto";
				}, 300);
			} else if (!visible && $section.classList.contains("-expanded")) {
				$section.classList.remove("-expanded");
				$section.style.height = $section.scrollHeight + "px";

				setTimeout(() => {
					$section.style.height = "0";
				}, 25);
			}
		}

		#refreshResults() {
			// Get inputs.
			const inputs = this.#getInputs();

			if (
				inputs.distance === null
				|| (inputs.carType === "plugin" && inputs.electricDistance === null)
				|| (
					(inputs.carType === "electric" || inputs.carType === "plugin")
					&& (inputs.electricConsumption === null || inputs.electricPrice === null)
				)
				|| (
					(inputs.carType === "standard" || inputs.carType === "plugin")
					&& (inputs.fuelConsumption === null || inputs.fuelPrice === null)
				)
			) {
				this.#setResults(null);
				return;
			}

			// Calculate electricity.
			let consumedElectricity = 0;
			let electricityPrice    = 0;

			if (inputs.carType === "electric" || inputs.carType === "plugin") {
				let electricDistance;

				if (inputs.carType === "plugin") {
					electricDistance = (inputs.distance > inputs.electricDistance)
						? inputs.electricDistance
						: inputs.distance;
				} else {
					electricDistance = inputs.distance;
				}

				consumedElectricity = (electricDistance * inputs.electricConsumption / 100);
				electricityPrice    = (consumedElectricity * inputs.electricPrice);
			}

			// Calculate fuel.
			let consumedFuel = 0;
			let fuelPrice    = 0;

			if (inputs.carType === "standard" || inputs.carType === "plugin") {
				let fuelDistance;

				if (inputs.carType === "plugin") {
					fuelDistance = (inputs.distance > inputs.electricDistance)
						? (inputs.distance - inputs.electricDistance)
						: 0;
				} else {
					fuelDistance = inputs.distance;
				}

				consumedFuel = (fuelDistance * inputs.fuelConsumption / 100);
				fuelPrice    = (consumedFuel * inputs.fuelPrice);
			}

			// Set results.
			this.#setResults({
				distance: inputs.distance,
				tripPrice: (electricityPrice + fuelPrice),
				kmPrice: ((electricityPrice + fuelPrice) / inputs.distance),
				consumedElectricity: consumedElectricity,
				consumedFuel: consumedFuel
			});
		}

		#setResults(results) {
			const $distance               = this.#$tripPriceResult.querySelector(".dan-result-distance");
			const $tripPriceVal           = this.#$tripPriceResult.querySelector(".dan-result-value");
			const $kmPriceVal             = this.#$kmPriceResult.querySelector(".dan-result-value");
			const $consumedElectricityVal = this.#$consumedElectricityResult.querySelector(".dan-result-value");
			const $consumedFuelVal        = this.#$consumedFuelResult.querySelector(".dan-result-value");

			if (results === null) {
				$distance.textContent               = "";
				$tripPriceVal.textContent           = "-";
				$kmPriceVal.textContent             = "-";
				$consumedElectricityVal.textContent = "-";
				$consumedFuelVal.textContent        = "-";

				this.#$consumedElectricityResult.style.display = "none";
				this.#$consumedFuelResult.style.display        = "block";

				return;
			}

			$distance.textContent               = results.distance;
			$tripPriceVal.textContent           = Dan_Utilities.smartFormat(results.tripPrice) + " Kč";
			$kmPriceVal.textContent             = Dan_Utilities.smartFormat(results.kmPrice) + " Kč";
			$consumedElectricityVal.textContent = Dan_Utilities.smartFormat(results.consumedElectricity) + " kWh";
			$consumedFuelVal.textContent        = Dan_Utilities.smartFormat(results.consumedFuel) + " l";

			this.#$consumedElectricityResult.style.display = (results.consumedElectricity > 0)
				? "block"
				: "none";
			this.#$consumedFuelResult.style.display        = (results.consumedFuel > 0)
				? "block"
				: "none";
		}

		#getInputs() {
			// Car type.
			let carType = null;

			for (const $input of this.#$carTypeInputs) {
				if ($input.checked) {
					carType = $input.value;
					break;
				}
			}

			// Distance.
			let distance;
			distance = this.#$distanceInput.value || this.#$distanceInput.placeholder;
			distance = parseInt(distance);

			if (distance < 0) {
				distance = null;
			}

			// Electric distance.
			let electricDistance;

			if (carType === "plugin") {
				electricDistance = this.#$electricDistanceInput.value || this.#$electricDistanceInput.placeholder;
				electricDistance = parseInt(electricDistance);

				if (electricDistance < 0) {
					electricDistance = null;
				}
			} else {
				electricDistance = null;
			}

			// Electric consumption & price.
			let electricConsumption;
			let electricPrice;

			if (carType === "electric" || carType === "plugin") {
				// Electric consumption.
				electricConsumption = this.#$electricConsumptionInput.value || this.#$electricConsumptionInput.placeholder;
				electricConsumption = parseFloat(electricConsumption);

				if (electricConsumption < 0) {
					electricConsumption = null;
				}

				// Electric price.
				electricPrice = this.#$electricPriceInput.value || this.#$electricPriceInput.placeholder;
				electricPrice = parseFloat(electricPrice);

				if (electricPrice < 0) {
					electricPrice = null;
				}
			} else {
				electricConsumption = null;
				electricPrice       = null;
			}

			// Fuel consumption & price.
			let fuelConsumption;
			let fuelPrice;

			if (carType === "standard" || carType === "plugin") {
				// Fuel consumption.
				fuelConsumption = this.#$fuelConsumptionInput.value || this.#$fuelConsumptionInput.placeholder;
				fuelConsumption = parseFloat(fuelConsumption);

				if (fuelConsumption < 0) {
					fuelConsumption = null;
				}

				// Fuel price.
				fuelPrice = this.#$fuelPriceInput.value || this.#$fuelPriceInput.placeholder;
				fuelPrice = parseFloat(fuelPrice);

				if (fuelPrice < 0) {
					fuelPrice = null;
				}
			} else {
				fuelConsumption = null;
				fuelPrice       = null;
			}

			// Return.
			return {
				carType,
				distance,
				electricDistance,
				electricConsumption,
				electricPrice,
				fuelConsumption,
				fuelPrice
			};
		}
	}

	// Initialize widgets.
	const $widgets = document.querySelectorAll(".energetiko-fuel-consumption-calculator");

	for (const $widget of $widgets) {
		$widget.calculator = new Fuel_Consumption_Calculator($widget);
		$widget.calculator.initialize();
	}
})();
